// extracted by mini-css-extract-plugin
module.exports = {"chatRoom":"ChatRoom_chatRoom__29noF","scrollTo":"ChatRoom_scrollTo__1wz3R"};